<template>
  <div class="base-summary">
    <p class="mb-0 text-muted">
      {{ label }}:
      <strong class="text-dark">{{ formatNumber(total) }}</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'BaseSummary',

  props: {
    total: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: 'Tổng số',
    },
  },

  methods: {
    formatNumber(num) {
      return new Intl.NumberFormat().format(num);
    },
  },
};
</script>
